import { useEffect } from "react";
import { useMySavedColorsModalStore } from "../../../js/stores/my-saved-colors-modal-store";
import { useMainReact } from "../../main-react";
import { Dialog, DialogContent } from "../shared/modal";
import { LoggedInColors } from "./logged-in-colors";
import { useMyLikedColorsStore } from "../../../js/stores/my-liked-colors-store";
import { LoggedOffColors } from "./logged-off-colors";
import { useLinkColors } from "../../../js/api/my-saved-colors/get-liked-colors";
import { useSyncLoaderStore } from "../../../js/stores/sync-loader-store";

function MySavedColorsDialog({ isModalOpen, updateIsModalOpen }) {
  const { isLoggedIn } = useMainReact();
  const isLikedStoreReady = useMyLikedColorsStore(
    (state) => state._hasHydrated
  );
  return (
    <Dialog
      open={isModalOpen}
      onClose={() => updateIsModalOpen(false)}
      onOpenChange={updateIsModalOpen}
    >
      <DialogContent className="react-modal-content--wide">
        {isLoggedIn && isLikedStoreReady && <LoggedInColors />}
        {!isLoggedIn && isLikedStoreReady && <LoggedOffColors />}
      </DialogContent>
    </Dialog>
  );
}

export function MySavedColorsModal() {
  const { isLoggedIn } = useMainReact();
  const isModalOpen = useMySavedColorsModalStore((state) => state.isModalOpen);
  const updateIsModalOpen = useMySavedColorsModalStore(
    (state) => state.updateIsModalOpen
  );

  const setIsLoading = useSyncLoaderStore((state) => state.setIsLoading);
  const likedColors = useMyLikedColorsStore((state) => state.likedColors);
  const resetColors = useMyLikedColorsStore((state) => state.resetColors);
  const syncColorsMutation = useLinkColors();
  useEffect(() => {
    if (likedColors?.length && isLoggedIn) {
      setIsLoading(true);
      syncColorsMutation.mutate({
        colorCodes: likedColors,
        successHandler: () => {
          setIsLoading(false);
          resetColors();
        },
        errorHandler: () => setIsLoading(false),
      });
    } else {
      setIsLoading(false);
    }
  }, []);

  return (
    <>
      {isModalOpen && (
        <MySavedColorsDialog
          key={crypto?.randomUUID()}
          isModalOpen={isModalOpen}
          updateIsModalOpen={updateIsModalOpen}
        />
      )}
    </>
  );
}
